const calendarChipsToggles = {
  actions: 'ACTIONS',
  services_performed: 'SERVICES DONE',
  services_to_be_performed: 'SERVICES TO BE DONE / OVERDUE',
  maintenances: 'MAINTENANCES',
  future_services: 'FUTURE SERVICES',
};

export default calendarChipsToggles;
